export default class PaginatedFetcher {
    fetcher;
    result = [];
    limit = 1000;
    offset = 0;
    total = 0;
    constructor(fetcher, limit = 1000) {
        this.fetcher = fetcher;
        this.limit = limit;
    }
    async fetchPage(params) {
        try {
            const response = await this.fetcher({ limit: this.limit, offset: this.offset, ...params });
            const result = response.data;
            this.result = this.result.concat(result.data || []);
            this.offset += this.limit;
            this.total = result.metadata.count;
            return result.data;
        }
        catch (e) {
            console.error(e);
        }
    }
    async fetchAll(params) {
        await this.fetchPage(params);
        while (this.result.length < this.total) {
            await delay(100);
            await this.fetchPage(params);
        }
        return this.result;
    }
}
function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
